import { Alert, AlertTitle, LinearProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ErrorBox } from "components/error";
import { useSolutionKey } from "features/solution";
import { useHistory } from "react-router-dom";
import { createRoute } from "utils/url";
import DataSourceItem from "./DataSourceItem";
import { useDataSources } from "./hooks/useDataSources";

const useStyles = makeStyles(theme => ({
  container: {
    width: "100%",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, 400px)",
    gap: 24,
    alignItems: "start",
    justifyContent: "start"
  },
  infoContainer: {
    padding: theme.spacing(2),
    border: "solid 1px #dcdcdc",
    width: "100%",
    marginTop: theme.spacing(2)
  }
}));

export default function DataSources() {
  const classes = useStyles();
  const solutionKey = useSolutionKey();
  const history = useHistory();
  const { data, loading, error } = useDataSources(solutionKey);
  const dataSources =
    data?.solutions.solution?.cloudDataSources?.dataSources ?? [];

  if (loading) return <LinearProgress />;
  if (error) return <ErrorBox apolloError={error} />;
  if (!dataSources.length)
    return (
      <Alert severity="info" className={classes.infoContainer}>
        <AlertTitle>No Data Sources Available</AlertTitle>
        There are currently no cloud data sources in this solution.
      </Alert>
    );

  return (
    <div className={classes.container} data-testid="data-source-list">
      {dataSources.map(dataSource => (
        <DataSourceItem
          key={dataSource.key}
          dataSource={dataSource}
          onClick={dataSourceKey =>
            history.push(
              createRoute(
                `/solutions/${solutionKey}/data-sources/${dataSourceKey}`
              )
            )
          }
        />
      ))}
    </div>
  );
}
